import { render, staticRenderFns } from "./pii-setting.vue?vue&type=template&id=39891743&scoped=true"
import script from "./pii-setting.vue?vue&type=script&lang=js"
export * from "./pii-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39891743",
  null
  
)

export default component.exports